import styled, {
  DefaultTheme,
  FlattenInterpolation,
  ThemeProps,
  css,
} from 'styled-components/macro';

import FlexContainer from 'components/FlexContainer/FlexContainer';
import Typography from 'components/Typography/Typography';

type CounterStyledT = {
  bgColor?: 'red' | 'green' | 'orange';
};

type IndentedClientsWrapStyledT = {
  isRoofTopSelected: boolean;
};

type ClientsTotalContainerStyledT = {
  isRoofTopIdFilterCleared: boolean;
};

const green = css`
  background-color: ${({ theme }) => theme.colors.secondary.variant2};
`;

const orange = css`
  background-color: ${({ theme }) => theme.colors.highlight.variant1};
`;

const red = css`
  background-color: ${({ theme }) => theme.colors.highlight.variant2};
`;

const background: { [key: string]: FlattenInterpolation<ThemeProps<DefaultTheme>> } = {
  green,
  orange,
  red,
};

export const ClientsWrapStyled = styled.section`
  margin: 2rem 0;
  color: rgb(108, 117, 125);
`;

export const IndentedClientsWrapStyled = styled(FlexContainer)<IndentedClientsWrapStyledT>`
  font-size: ${({ theme }) => theme.fontSize.sm};
  padding: 0.688rem 1.875rem;
  background-color: ${({ theme, isRoofTopSelected }) =>
    isRoofTopSelected ? theme.colors.rgba.variant2 : theme.colors.transparent};
  cursor: pointer;

  &:hover {
    background-color: ${({ theme }) => theme.colors.rgba.variant2};
  }
`;

export const ClientsHeadStyled = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 0 1.875rem;
  margin-bottom: 0.5rem;
`;

export const ClientContainerStyled = styled.div`
  font-size: ${({ theme }) => theme.fontSize.md};
  display: flex;
  flex-shrink: 0;
  justify-content: left;
  align-items: right;
  width: 32%;
  padding-right: 8px;
  line-height: 13px;
  gap: 6px;
`;

export const AmountContainerStyled = styled.div`
  font-size: ${({ theme }) => theme.fontSize.md};
  display: flex;
  flex-shrink: 0;
  justify-content: right;
  align-items: right;
  width: 32%;
  padding-right: 8px;
  line-height: 13px;
  gap: 6px;
`;

export const CountersContainerStyled = styled.div`
  display: flex;
  flex-shrink: 0;
  justify-content: space-between;
  align-items: center;
  width: 40%;
  padding-right: 2px;
  line-height: 13px;
  gap: 6px;
`;

export const CountersTotalStyled = styled.div`
  display: flex;
  flex-shrink: 0;
  justify-content: space-between;
  align-items: center;
  width: 50%;
  padding-left: 8px;
  line-height: 13px;
  gap: 10px;
`;

export const TextTotalStyled = styled(Typography)`
  width: 100%;
`;

export const ClientsListContainerStyled = styled.div`
  max-height: calc(100vh - 250px);
  overflow: auto;
`;

export const ClientsTotalContainerStyled = styled(FlexContainer)<ClientsTotalContainerStyledT>`
  padding: 0.688rem 1.875rem;
  position: relative;
  color: rgb(233, 236, 239);
  background-color: ${({ theme, isRoofTopIdFilterCleared }) =>
    isRoofTopIdFilterCleared ? theme.colors.rgba.variant2 : theme.colors.transparent};
  cursor: pointer;

  &:hover {
    background-color: ${({ theme }) => theme.colors.rgba.variant2};
  }
`;

export const TextClientsStyled = styled(Typography)`
  width: 34%;
  color: ${({ theme }) => theme.colors.primary.variant6};
  opacity: 0.7;
`;

export const TextAmountStyled = styled(Typography)`
  text-align: left;
  width: 34%;
  color: ${({ theme }) => theme.colors.primary.variant6};
  opacity: 0.7;
  margin-left: 14px;
`;

export const TextRightHeaderStyled = styled(Typography)`
  text-align: center;
  font-size: ${({ theme }) => theme.fontSize.sm};
  font-weight: ${({ theme }) => theme.fontWeight.semibold};
  color: ${({ theme }) => theme.colors.primary.variant6};
  opacity: 0.7;
  white-space: nowrap;
`;

export const CounterStyled = styled.div<CounterStyledT>`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 50%;
  margin: auto;
  padding: 0;
  gap: 10px;
  background-color: rgba(0, 0, 0, 0.16);
  color: ${({ theme }) => theme.colors.primary.variant3};
  font-size: ${({ theme }) => theme.fontSize.sm};
  font-weight: ${({ theme }) => theme.fontWeight.bold};
  text-align: center;
  line-height: 24px;
  border-radius: 12px;

  ${({ bgColor = 'rgba(0, 0, 0, 0.16)' }) => background[bgColor]};
`;

export const TextRooftTopNameStyled = styled(Typography)`
  max-width: 150px;
  max-height: 4.5em;
  line-height: 1.5em;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
  overflow-wrap: break-word;
  text-overflow: ellipsis;
`;

export const ObserverSpanStyled = styled.span`
  margin: 16px;
  color: ${({ theme }) => theme.colors.primary.variant1};
`;
